<template>
    <div class="job-post">
        <LoadingIndicator v-if="loading" message="Loading Job Post..."/>
        <SystemMessage v-if="!loading && error" :message="message"/>
        <div class="preview" v-if="!loading && !error">
            <!-- start of preview -->
             <div class="job-card">
    <img :src="profileImage" 
    @error="setDefaultImage"
    alt="Company logo"
     class="logo" />
    <div class="details">
       <div class="company">
        
        <div class="job-title">
          {{ jobItem.jobTitle }}  
        </div>
        <div class="company-name">
          {{ jobItem.name }}
        </div>
      </div>
      <div class="type job-detail">
        <BriefcaseJobIcon class="job-icon"/><div class="detail">{{ jobItem.jobType || '--' }}</div>
      </div>
      <div class="location job-detail">
        <PinIcon class="job-icon"/><div class="detail">{{ jobItem.location }}</div> 
      </div>
      
      <div class="closing-date job-detail">
        <CalendarIcon class="job-icon"/> <div class="detail">{{ jobItem.closingDate }}</div>
      </div>
      <button @click="copyLink(jobItem.encodedJobId)" class="btn btn-default btn-sm copy-btn">
        <CopyIcon class="copy-icon"/>
        <div class="copy-text">
          {{ isCopied ? 'Copied!' : 'Copy Link' }}
        </div>
      </button>
      <div class="description" v-html="formattedDescription(jobItem.description)"></div>
      

      <!-- Buttons container -->
      <div class="actions">
        <button class="btn btn-default apply-btn" @click="apply">Apply</button>
        <button class="btn btn-default save-btn" :disabled="saving"  @click="saveJob">{{ saveBtnLabel }}</button>
      </div>
    </div>
  </div>
             <!-- end -->
        </div>
        
    <ApplyToJobModal ref="applyJob" modal-id="applyToJob"/>
    <CustomConfirmationMessageModal :title="modal.caption"
                ref="saveJobModal"
            :body="modal.message"
            :button-label="modalButtonLabel"
            :close-modal="() => closeModal()"
            :modal-id="modalId"/>
    </div>
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import ApplyToJobModal from '@/components/modals/ApplyToJobModal.vue';
import { getJobPostAsync, ToggleSaveJobAsync } from '@/services/public/vacancyService';
import BriefcaseJobIcon from '@/components/IconComponents/BriefcaseJobIcon.vue';
import PinIcon from '@/components/IconComponents/PinIcon.vue';
import CalendarIcon from '@/components/IconComponents/CalendarIcon.vue';
import CopyIcon from '@/components/IconComponents/CopyIcon.vue';
import DOMPurify from 'dompurify'
import { setPageMeta, stripHtmlTags } from '@/assets/pageMetaGenerator';
export default {
    components:{
        LoadingIndicator,
        SystemMessage,
        CustomConfirmationMessageModal,
        ApplyToJobModal,
        BriefcaseJobIcon,
        PinIcon,
        CalendarIcon,
        CopyIcon
    },
    data(){
        return{
             url:process.env.VUE_APP_API_URL,
             site_url: process.env.VUE_APP_SITE_URL,
            loading: true,
            error: false,
            message: "",
             jobItem: {
              id:'',
              name:'',
              jobId:'',
              jobTitle:'',
              location:'',
              closingDate:'',
              description:'',
              jobType:'',
              isSaved: null,
              encodedJobId:'',
            },
            // saveBtnLabel : "Save",
            saving: false,
            modal:{
                        caption:"",
                        message:""
                    },
                    modalButtonLabel:'Close',
                    modalId:"saveJobPrev",
            isCopied: false
        }
    },
     computed:{
            saveBtnLabel(){
                if(this.jobItem.isSaved == true){
                 return "Unsave";
                }else{
                 return "Save";
                }
            },
            profileImage(){
            return this.url + 'Auth/Image/' + this.jobItem.id;
            },
            authUser(){
            return this.$store.getters['auth/getAuthenticatedUser'] || null;
            }
    },
    async mounted(){
        await this.getJobPost();
    },
    methods:{
        updateMeta(){
          setPageMeta({
            title: `${this.jobItem.jobTitle} - ${this.jobItem.name}`,
            description: `${this.jobItem.jobType} . ${this.jobItem.location} . ${this.jobItem.closingDate}`,
            image: this.profileImage,
            url: window.location.href,
          })
        },    
        async getJobPost(){
            try{
                this.loading = true;
                this.error = false;
                let response = await getJobPostAsync(this.$route.params.jobid);
                 this.loading = false;
                if(!response.success){
                    let err = new Error(response.message);
                    throw err;
                }else{
                   
                        let job = response.vacancy;
                        this.jobItem.id = job.company.id;
                        this.jobItem.name = job.company.name;
                        this.jobItem.jobId = job.jobId;
                        this.jobItem.jobTitle = job.jobTitle;
                        this.jobItem.location = job.location;
                        this.jobItem.closingDate = job.closingDate;
                        this.jobItem.description = job.description;
                        this.jobItem.jobType = job.jobType;
                        this.jobItem.isSaved = job.isSaved;
                        this.jobItem.encodedJobId = job.encodedJobId;
                        this.updateMeta();
                        
                }
            }catch(e){
                this.loading = false;
                this.error = true;
                this.message = e.message || "Unable to get Job Post. Please try again later"
            }
           
        },
        async copyLink(jobId){
            let url = `${window.location.origin}/jobpost/${jobId}`
            
            // Check if the modern Clipboard API is available
            if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(url)
                this.showSuccess()
            } catch (err) {
                
                this.fallbackCopy(url);
            }
            } else {
            // Fallback for insecure raw IP addresses (HTTP)
            this.fallbackCopy(url);
            }
         },
         fallbackCopy(textToCopy) {
            // Create a temporary hidden textarea element
            const textArea = document.createElement('textarea')
            textArea.value = textToCopy
            
            // Avoid scrolling to the bottom of the page when appending
            textArea.style.top = '0'
            textArea.style.left = '0'
            textArea.style.position = 'fixed'
            
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select() // Highlight the text inside

            try {
            // Execute the legacy copy command
            const successful = document.execCommand('copy')
            if (successful) {
                this.showSuccess()
            } else {
                alert('Unable to copy link.')
            }
            } catch (err) {
            alert('Oops, unable to copy!')
            }

            // Clean up by removing the element from the DOM
            document.body.removeChild(textArea)
        },
        showSuccess(){
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                },3000);
        },
           async saveJob(){
                    try{
                    if(this.canAccess('enterprise')){
                        this.logOutToSignUp();
                        return;
                    }
                    this.saveBtnLabel = "Saving...";
                    this.saving = true;
                    var response = await ToggleSaveJobAsync(this.jobItem.jobId)
                            if(!response.success){
                                this.saveBtnLabel = "Save";
                                this.saving = false;
                                const err = new Error(response.message, {reason: response.caption});
                                err.caption = response.caption;
                                throw err;          
                                }else{
                               
                                this.jobItem.isSaved = response.isSaved;
                                this.saving = false;
                                this.modal.caption = "Vacancy";
                                this.modal.message = response.message;
                                this.showModal();   
                            }
                        }catch(e){
                            this.saveBtnLabel = "Save";
                            this.saving = false;
                            this.modal.caption = e.reason;
                            this.modal.message = e.message;
                            this.showModal(); 
                        }
                    },
                 apply(){
                        if(this.canAccess('enterprise')){
                            //logged out if logged in as other user to sign up for another account
                            //should work even if no log in session is present
                            this.logOutToSignUp();
                            return;

                        }
                        this.$refs.applyJob.setVacancyDetails(this.jobItem);
                        this.$refs.applyJob.show();
                    },
                 closeModal(){
                    if (this.$refs.saveJobModal && typeof this.$refs.saveJobModal.hide === 'function') {
                        this.$refs.saveJobModal.hide();
                        }    
                    },
                showModal(){
                        this.$refs.saveJobModal.show();
                    },
                danger(){
                    //this.confirmModalInstance2.show();
                    },
                logOutToSignUp(){
                        this.$store.dispatch('auth/logout');
                    
                        this.$router.push({path:'/login',
                                    query: {
                                        message: "You have to log in first"
                                    }});
                    },
                send(){
                
                },
                setDefaultImage(event) {
                    event.target.src = require('@/assets/images/profile_picture.png');
                },
                formattedDescription(description) {
                  if (!description) return '';

                  // 1. Sanitize raw input (Strips XSS + <img> tags)
                  let updated = DOMPurify.sanitize(description, { FORBID_TAGS: ['img'] });

                  // 2. Convert <ol> tags into <ul> tags (and strip list type attributes)
                  updated = updated.replace(/<ol(\s[^>]*)?>/gi, '<ul>');
                  updated = updated.replace(/<\/ol>/gi, '</ul>');

                  // 3. Strip existing inline background-color from user input
                  updated = updated.replace(/background-color:\s*[^;"]+;?/gi, '');

                  // 4. Strip existing inline text color from user input
                  updated = updated.replace(/color:\s*[^;"]+;?/gi, '');

                  // 5. Inject your custom theme styles into <p> tags safely
                  updated = updated.replace(
                    /<p(\s[^>]*)?>/g,
                    '<p$1 style="background-color:transparent;color:var(--foreground);padding:0rem;border-radius:0px;margin-bottom:1rem;">'
                  );

                  // 6. Remove empty paragraphs
                  updated = updated.replace(/<p[^>]*><br><\/p>/g, '');

                  return updated;
                },
                canAccess(routeName) {
                        if(this.authUser != null){
                        // Resolve the route by name. `resolved.matched` contains the matched route records.
                        const resolved = this.$router.resolve({ name: routeName })
                        // Use the most-specific matched record (last entry) so child route meta is respected.
                        const matched = resolved?.matched || []
                        if (!matched.length) return false // route not found
                        const record = matched[matched.length - 1]
                        const meta = record.meta || {}
                        // Read token from localStorage (used by guards elsewhere in the app).
                        const token = localStorage.getItem('token')
                        // Prefer the `authUser` from the Vuex store. Fall back to the `user` stored in localStorage.
                        let user = this.authUser.value
                        if (!user) {
                            try {
                            user = JSON.parse(localStorage.getItem('user'))
                            } catch (e) {
                            user = null
                            }
                        }
                        // If the route requires authentication and there's no token, deny access.
                        if (meta.requiresAuth && !token) {
                            return false
                        }
                        // If the route specifies allowed roles, check the user's role in multiple possible shapes:
                        //  - user.roles: an array of role strings
                        //  - user.userType: a single role stored under `userType` (used in signup)
                        //  - user.role: another common single-role field
                        if (meta.roles) {
                            let hasRole = false
                            if (Array.isArray(user?.roles)) {
                            hasRole = user.roles.some(role => meta.roles.includes(role))
                            } else if (user?.userType) {
                            hasRole = meta.roles.includes(user.userType)
                            } else if (user?.role) {
                            hasRole = meta.roles.includes(user.role)
                            }
                            if (!hasRole) return false
                        }
                        // No checks failed — allow access.
                        return true;
                        }else{
                        return true;
                        }
                    }
                
    }
}
</script>
<style scoped>
    .job-post{
        margin:3rem 1.6rem;
    }

    .copy-icon{
  color:var(--darkgrey3);
  height:1rem;
}

.copy-text{
  color:var(--darkgrey3);
  font-family:var(--body-font);
  font-size:0.8rem;
}

.copy-btn{
  display: flex;
  align-items: center;
  column-gap:0.3rem;
  background-color: var(--background);
  border-radius: 8px;
  margin-top:0.8rem;
  margin-bottom:1rem;
  
}

.job-title{
   font-family: var(--heading-font-bold);
   font-size:1.3rem;
   color:var(--job-title);
   white-space:wrap;

}

.company-name{
  font-family: var(--heading-font-bold);
  font-size:0.9rem;
  margin-bottom:0.4rem;
  white-space:wrap;
}

.job-detail{
  display: flex;
  align-items: center;
  color:var(--darkgrey3);
}



.detail{
  font-family: var(--body-font);
  font-size:0.9rem;
  
}

.job-icon{
  height:1rem;
  margin-right:0.4rem;
  margin-top:-0.2rem;
  color:var(--darkgrey3);
}



.job-card {
  display: flex;
  flex-direction: column; /* stack vertically */
  align-items: flex-start; /* keep everything left-aligned */
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1rem;
  margin-right:0.5rem;
  background-color: var(--list-item);
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem; /* space below image */
  border-radius: 4px;
  object-fit: cover;
  align-self: flex-start; /* force logo to left */
}

.details {
  width: 100%;
}

.details h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.description {
  white-space: pre-line;
  margin-top:1rem;
  margin-bottom: 1rem;
  font-family: var(--body-font);
}





/* Buttons container */
.actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem; /* space between buttons */
}

/* Apply button styling */
.apply-btn {
  padding: 0.5rem 1rem;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}



/* Save button styling */
.save-btn {
  padding: 0.5rem 1rem;
  background-color: #b121d156;
  color: white;
  border: none;
  border-radius: 4px;
  /* font-weight: bold; */
  cursor: pointer;
}



.location, .type, .closing-date{
  font-family: var(--heading-font2-regular);
}

/* Larger screens */
@media (max-width: 768px) {

    .job-post{
        margin:1rem 0.3rem;
    }

  .job-card {
    align-items: flex-start; /* keep left alignment even on desktop */
    margin-left:0rem;
    background-color: var(--modal-background);
  }

  .description {
  margin-top:0.5rem;
  line-height:1.1rem;
  font-size:0.9rem;
  
  }

  .location, .type, .closing-date{
   font-size:0.9rem;
}

  .company{
    font-size:1.2rem;
  }
}
</style>